import script from "./UserPayments.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPayments.vue?vue&type=script&setup=true&lang=js"

import "./UserPayments.vue?vue&type=style&index=0&id=35704995&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35704995"]])

export default __exports__